import { render, staticRenderFns } from "./PivotTotal.vue?vue&type=template&id=18494b98&scoped=true"
import script from "./PivotTotal.vue?vue&type=script&lang=js"
export * from "./PivotTotal.vue?vue&type=script&lang=js"
import style0 from "./PivotTotal.vue?vue&type=style&index=0&id=18494b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18494b98",
  null
  
)

export default component.exports